export default __webpack_public_path__ + "static/media/14.5d5d8077.svg";